import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaList, FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import NavItem from '../../components/NavItem';
import IconButton from '../../components/IconButton';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import { pontoVirgula } from '../../util/util';

export default function PainelProdutoOrcamento() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setFiltro(prev => ({ ...prev, buscando: true }));
        api({
            method: 'get',
            action: '/produto',
            token: token,
            params: {
                ...filtro, ...{ modulo: 'orcamento' }
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setProdutos(response.data.data);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                //console.log(err)
            })
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroProdutoOrcamento" icon={<FaPlus size={20} />} color="primary">Novo Produto</NavItem>
                    <NavItem to="/produtoUnidadeNegocio" icon={<FaList size={20} />} color="outline-dark">Unidades de Negócios</NavItem>
                    <NavItem to="/produtoBu" icon={<FaList size={20} />} color="outline-dark">BU's</NavItem>
                    <NavItem to="/produtoLinha" icon={<FaList size={20} />} color="outline-dark">Linhas</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Produtos</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="nome" placeholder="Buscar pelo nome do serviço"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Nome</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            persistTableHead
                                            progressComponent={<TabelaLoading />}
                                            noDataComponent={<TabelaVazia />}
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: row => <IconButton
                                                        small={true}
                                                        to={"/cadastroProdutoOrcamento/" + row.id}
                                                        icon={<FaPen size={20} />}
                                                        color="primary">Alterar</IconButton>,
                                                    width: "120px",
                                                },
                                                {
                                                    name: 'Nome',
                                                    selector: row => row.nome ?? "",
                                                    sortable: true,
                                                },
                                                {
                                                    name: 'Bu',
                                                    selector: row => row.bu?.nome ?? "",
                                                    sortable: true,
                                                },
                                                {
                                                    name: 'Unidade de Negócios',
                                                    selector: row => row.bu?.unidadenegocio?.nome ?? "",
                                                    sortable: true,
                                                },
                                            ]}
                                            data={produtos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
